import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sparky_admin_token');
    if (token) {
      api.get('/auth/me').then(r => setAdmin(r.data)).catch(() => localStorage.removeItem('sparky_admin_token')).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginAdmin = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('sparky_admin_token', data.token);
    setAdmin(data.user);
    return data;
  };

  const logoutAdmin = () => {
    localStorage.removeItem('sparky_admin_token');
    setAdmin(null);
  };

  const loginCustomer = (token, customerData) => {
    localStorage.setItem('sparky_customer_token', token);
    setCustomer(customerData);
  };

  const logoutCustomer = () => {
    localStorage.removeItem('sparky_customer_token');
    setCustomer(null);
  };

  return (
    <AuthContext.Provider value={{ admin, customer, loading, loginAdmin, logoutAdmin, loginCustomer, logoutCustomer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
